import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContextProvider } from '../../store/selection-context-provider'
import CompletedInquiriesList from './completed-inquries-list'

const CompletedInquiries = () => {
  usePageTitle(PAGE_TITLE.COMPLETED_INQUIRIES)
  const navigate = useNavigate()
  const { allMPF, isLoading } = useContext(RoleContext)
  if (!isLoading) {
    if (!allMPF) {
      navigate('/accessdenied')
    }
  }
  return (
    <SelectionContextProvider>
      <CompletedInquiriesList />
    </SelectionContextProvider>
  )
}
export default CompletedInquiries
